<div
    class="alert"
    data-cy="wdx-alert"
    [class.d-flex]="allowFlex"
    [class.align-items-center]="allowFlex"
    [class.rounded-0]="!rounded"
    [ngClass]="themeClass"
>
    <ng-content></ng-content>
</div>
